import axios from 'axios'
import { BACKEND_URL } from '../constants'

// axios configuration
const Axios =  axios.create({
  baseURL: BACKEND_URL,
})

export default Axios
